(ns dashboard.entity.question.search
  (:require ["react" :as react]
            [clojure.string :as str]
            [dashboard.entity.analysis.search :as analysis.search]
            [dashboard.entity.question.profile :as question.profile]))

(defn QuestionSearchInput
  [{:keys [perform-search
           question
           query
           set-query
           use-hierarchy-context
           set-use-hierarchy-context]}]
  [analysis.search/SearchInput
   {:query-mode :semantic
    :set-query-mode identity
    :set-query set-query
    :search-actions [:f> analysis.search/QuestionFilterOptions
                     {:use-hierarchy-context use-hierarchy-context
                      :set-use-hierarchy-context set-use-hierarchy-context
                      :perform-search perform-search
                      :question question}]
    :props {:value query
            :on-change (fn [e] (-> e .-target .-value set-query))
            :type :search
            :placeholder "Type your query to filter Analyses by words and fragments. Use double-quotes to match phrases."}
    :search-context :question
    :wrapper-class :question-semantic-search}])

(defn QuestionSearch
  "The Question Search Component - expects to be framed with reference to a
   question via Question answering.

   Accepts a map with keys:
   - question
   - on-question-selected
   - filter-actions
   - initial-search
   - hide-input
   - path
   - search-actions"
  [{:keys [question
           on-question-selected
           filter-actions
           initial-search
           hide-input
           path
           search-actions]}]
  (let [hierarchy-context (->> (mapv :content (:tree/ancestor-nodes question))
                               (interpose " : ")
                               (apply str))
        ; subs
        query @(analysis.search/get-search-query* path (:query initial-search))
        ; Used to trigger re-render from cached search results
        query-id @(analysis.search/get-search-query-id* path)
        external-query-update nil ;@(rf/subscribe [::get-external-query-update path])

        search-context @(analysis.search/get-search-query-context* path hierarchy-context)
        loading-recommendations @(analysis.search/loading-recommendations*)

        search-results-data @(analysis.search/get-search-results* path)
                    ; state
        [display-query  set-display-query] (react/useState query)
        [use-hierarchy-context set-use-hierarchy-context] (react/useState
                                                           (boolean (seq search-context)))
        [query-mode set-query-mode] (react/useState (or (:mode initial-search)
                                                        :semantic))
        [show-input set-show-input] (react/useState false)
        [date-range set-date-range] (react/useState 3)
                    ; handlers
        set-query #(analysis.search/set-search-query path % true)
        analyses @(analysis.search/all-analysis-structures)
        on-search (partial analysis.search/debounced-search
                           {:mode :semantic
                            :path path
                            :context (when use-hierarchy-context
                                       hierarchy-context)
                            :set-query set-query
                            :date-range date-range})
        on-update-query (fn [query]
                          (set-display-query query)
                          (on-search query))
        on-change-date-range (fn [value]
                               (set-date-range value)
                               (analysis.search/debounced-search
                                {:mode :semantic
                                 :path path
                                 :context (when use-hierarchy-context
                                            hierarchy-context)
                                 :set-query set-query
                                 :date-range value}
                                query))
        on-set-use-hierarchy-context (fn []
                                       (analysis.search/debounced-search
                                        {:mode :semantic
                                         :path path
                                         :context (when (not use-hierarchy-context)
                                                    hierarchy-context)
                                         :set-query set-query
                                         :date-range date-range}
                                        query)
                                       (set-use-hierarchy-context not))]
    (react/useEffect
     (fn [_] (set-display-query query))
     #js [external-query-update])

    (react/useEffect
     (fn [_]
       (when-not (str/blank? query)
         (analysis.search/perform-search
          {:mode (or query-mode :exact)
           :path path
           :analyses analyses
           :context (when (and question use-hierarchy-context)
                      (->> (mapv :content (:tree/ancestor-nodes question))
                           (interpose " : ")
                           (apply str)))
           :set-query set-query
           :date-range date-range}
          query)))
     #js [nil])

    [:div.analysis-search
     [:div.level.is-flex.is-align-items-flex-start
      (when-not hide-input
        (if show-input
          [:f> QuestionSearchInput
           {:query-mode query-mode
            :query display-query
            :question question
            :perform-search on-update-query
            :set-query-mode set-query-mode
            :set-query on-update-query
            :use-hierarchy-context use-hierarchy-context
            :set-use-hierarchy-context on-set-use-hierarchy-context
            :search-actions search-actions
            :props {:value display-query
                    :on-change (fn [e] (-> e .-target .-value  on-update-query))}
            :wrapper-class ""}]
          [:div
           [:button.button.is-info.is-outlined
            {:on-click #(set-show-input true)}
            [:i.icon.fas.fa-search.mr-3]
            "Refine Search"]]))
      [:div.level-right.ml-3.is-flex
       [:div "Results from:"]
       [:select.mx-2.input
        {:style {:width "200px"}
         :on-change (fn [e] (on-change-date-range (-> e
                                                      .-target
                                                      .-value
                                                      str
                                                      js/parseInt)))
         :value date-range}
        [:option {:value 3} "Previous 3 months"]
        [:option {:value 6} "Previous 6 months"]
        [:option {:value -1} "All Time"]]]]
     filter-actions
     (if (and loading-recommendations (empty? search-results-data))
       "Loading..."
       (->> search-results-data
            :questions
            (remove (comp (partial = (:questionnaire-id question)) :questionnaire-id))
            (take 10)
            (mapv (partial question.profile/QuestionAsOption on-question-selected))
            (into [:<>])))]))